import { render, staticRenderFns } from "./requisitions.vue?vue&type=template&id=36e757a0&"
import script from "./requisitions.vue?vue&type=script&lang=js&"
export * from "./requisitions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports